import { render, staticRenderFns } from "./WebhookSlack.vue?vue&type=template&id=1834649c&"
import script from "./WebhookSlack.vue?vue&type=script&lang=js&"
export * from "./WebhookSlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports